import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const Alert = (props: AlertProps) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(() => ({
  snackroot: {
    bottom: 0
  },
  alertroot: {
    borderRadius: '12px 12px 0px 0px',
    padding: 20
  },
  darkAlert: {
    backgroundColor: '#697683'
  }
}));

type PropsFunction = (event?: React.SyntheticEvent, reason?: string) => void

export default function CustomizedSnackbars({ open, type, message, onClose }: { open: boolean, type: any, message: string, onClose: PropsFunction }) {
  const classes = useStyles();

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway' && event) {
      return;
    }
    onClose();
  };

  return (
    <Snackbar open={open} autoHideDuration={5000} classes={{ root: classes.snackroot }} onClose={handleClose}>
      {type === 'dark' ? (
        <Alert onClose={handleClose} severity={'error'} classes={{ root: clsx(classes.alertroot, classes.darkAlert) }}>{message}</Alert>
      ) : (
        <Alert onClose={handleClose} severity={type} classes={{ root: classes.alertroot }}>{message}</Alert>
      )}
    </Snackbar>
  );
}
